import { useIntl } from "react-intl";
import StepLabel from "../StepLabel";
import Warning from "../Warning";
import { useFormContext } from "./form-context";
import { FormInput, FormPhoneInput } from "./form-inputs";
import { FormInputsContainer } from "./styles";
import { FormContainer } from "../../styles";

export function PixMethod() {
  const intl = useIntl();
  const { pixForm } = useFormContext();
  const { control } = pixForm;
  return (
    <FormContainer autocomplete="off">
      <StepLabel number={2} text={"buyer_info"} />
      <FormInputsContainer>
        <FormInput
          control={control}
          name={"name"}
          label={"name"}
          placeholder={intl.formatMessage({
            id: "name",
          })}
        />

        <FormInput
          control={control}
          name={"document"}
          label={"CPF_or_passport"}
          placeholder="123.456.789-10 / AB0000000"
        />

        <FormPhoneInput
          control={control}
          name={"phone"}
          label={"phone2"}
          placeholder="(11) 98765-4321"
        />

        <FormInput
          control={control}
          name={"cardReader"}
          label={"card_reader"}
          placeholder={intl.formatMessage({
            id: "serial_number",
          })}
        />
      </FormInputsContainer>
      <Warning />
    </FormContainer>
  );
}
